module.exports = {"1":"Scarso","2":"Mediocre","3":"Accettabile","4":"Molto buono","5":"Eccezionale","1.5":"Scarso","2.5":"Mediocre","3.5":"Accettabile","4.5":"Eccezionale"}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/resources/localization/it-IT/star-ratings.json
// module id = 1311
// module chunks = 0